const QUERIES = {
  USERS_LIST: 'users-list',
  GET_USER_BY_ID: 'get-user-by-id',
  REGIONS_LIST: 'regions-list',
  REGIONS_LIST_ALL: 'regions-list-all',
  REGIONS_REPORT_REVENUE: 'regions-report-revenue',
  REGIONS_REPORT_INVESTMENT: 'regions-report-investment',
  ROLES_LIST: 'roles-list',
  ROLES_LIST_ALL: 'roles-list-all',
  OFFICES_LIST: 'offices-list',
  OFFICES_LIST_BY_USER: 'offices-list-by-user',
  OFFICES_LIST_BY_USER_IN_AREA: 'offices-list-by-user-in-area',
  GET_OFFICE_BY_ID: 'get-office-by-id',
  AREAS_LIST: 'areas-list',
  AREAS_LIST_BY_USER: 'areas-list-by-user',
  AREAS_LIST_BY_USER_ALL: 'areas-list-by-user-all',
  CHECK_SETUP_REVENUE_NORM: 'check-setup-revenue-norm',
  CHECK_MODIFY_REVENUE_NORM: 'check-modify-revenue-norm',
  GET_AREA_BY_REGION: 'get-area-by-region',
  GET_REWARD: 'get-reward',
  GET_REPORT_REVENUE: 'get-report-revenue',
  GET_REVENUE_NORM: 'get-revenue-norm',
  GET_OFFICE_REVENUE_NORM: 'get-office-revenue-norm',
  GET_REPORT_REVENUE_BY_REGION: 'get-report-revenue-by-region',
  GET_REPORT_REVENUE_BY_AREA: 'get-report-revenue-by-area',
  GET_REPORT_REVENUE_BY_OFFICE: 'get-report-revenue-by-office',
  GET_REPORT_REVENUE_CHART: 'get-report-revenue-chart',
  GET_REPORT_WEAK_BRANCH_REVENUE: 'get-report-weak-branch-revenue',
  GET_REPORT_PARTNER: 'get-report-partner',
  GET_REPORT_PARTNER_CUSTOMER_CHART: 'get-report-partner-customer-chart',
  GET_REPORT_PARTNER_BY_REGION: 'get-report-partner-by-region',
  GET_REPORT_PARTNER_BY_AREA: 'get-report-partner-by-area',
  GET_REPORT_PARTNER_BY_OFFICE: 'get-report-partner-by-office',
  GET_REPORT_INSTALLMENT: 'get-report-installment',
  GET_REPORT_INSTALLMENT_BY_REGION: 'get-report-installment-by-region',
  GET_REPORT_INSTALLMENT_BY_AREA: 'get-report-installment-by-area',
  GET_REPORT_INSTALLMENT_BY_OFFICE: 'get-report-installment-by-office',
  GET_CUSTOMER_INSTALLMENT_OVERDUE: 'get-customer-installment-overdue',
  GET_REPORT_INSTALLMENT_OVERDUE: 'get-report-installment-overdue',
  GET_CUSTOMER_INSTALLMENT_OVERDUE_BY_REGION: 'get-customer-installment-overdue-by-region',
  GET_CUSTOMER_INSTALLMENT_OVERDUE_BY_AREA: 'get-customer-installment-overdue-by-area',
  GET_CUSTOMER_INSTALLMENT_OVERDUE_BY_OFFICE: 'get-customer-installment-overdue-by-office',
  GET_CUSTOMER_PARTNER_LIST: 'get-customer-partner-list',
  GET_CUSTOMER_PARTNER_DETAIL_LIST: 'get-customer-partner-detail-list',
  GET_CUSTOMER_PARTNER_DETAIL_BY_AREA_LIST: 'get-customer-partner-detail-by-area-list',
  GET_CUSTOMER_PARTNER_REPORT_CUSTOMER_NUMBER: 'get-customer-partner-report-customer-number',
  GET_CUSTOMER_PARTNER_REPORT_CUSTOMER_IN_ACTIVE: 'get-customer-partner-report-customer-inactive',
  GET_CUSTOMER_PARTNER_REPORT_CUSTOMER_CONTRIBUTION: 'get-customer-partner-report-customer-contribution',
  COURSE_LIST: 'course-list',
  GET_COURSE: 'get-course',
  NOTIFICATION_LIST: 'notification-list',
}

export { QUERIES }
